export default __webpack_public_path__ + "images/pictograms/upload.svg?bb4eb87f8a7ce32b52c85212c4166f288eb1178970223bcd0816f654d7e1e530";